export const SET_USER = "SET_USER";
export const SET_TOKEN = "SET_TOKEN";
export const SET_ERROR = "SET_ERROR";
export const LOGOUT = "LOGOUT";
export const RESET_ERROR = "RESET_ERROR";
export const RESET_TOKEN = "RESET_TOKEN";
export const SET_USER_IS_SUBSCRIBED = "SET_USER_IS_SUBSCRIBED";
export const SET_USER_BILLING_PORTAL = "SET_USER_BILLING_PORTAL";
